import {
  ButtonLooks,
  ButtonSizes,
  DialogSizes,
  StandardButton,
  StandardDialog,
  brandfolderColorPalette,
} from '@brandfolder/react';
import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const StyledDialog = styled(StandardDialog)`
  &.people-tag-scope-confirm-modal {
    height: 100vh;
  }

  .bf-dialog__type {
    height: fit-content;
    min-height: unset;
  }

  .bf-dialog__heading {
    font-weight: 700;
  }

  .bf-dialog__inner {
    height: fit-content;
  }

  .bf-dialog__body {
    padding: 0 24px 24px;
  }

  .bf-dialog__footer {
    margin-top: 0;
  }

  .bf-dialog__footer {
    padding: 0px 30px 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const BodyText = styled.p`
  color: ${brandfolderColorPalette.neutrals[700]};
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 20px;
`;

const ListTitleText = styled.p`
  color: ${brandfolderColorPalette.neutrals[700]};
  font-size: 14px;
  line-height: 1.5;
  margin: 10px 0 0;
`;

const List = styled.ul`
  color: ${brandfolderColorPalette.neutrals[700]};
  line-height: 1.5;
  margin: 0 0 20px;
  padding-left: 20px;

  li {
    font-size: 14px;
  }
`;

interface PeopleTaggingDisableModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onDisable: () => void;
}

const PeopleTaggingDisableModal: FunctionComponent<PeopleTaggingDisableModalProps> = ({
  isOpen,
  onCancel,
  onDisable
}) => {
  return (
    <StyledDialog
    className="people-tag-scope-confirm-modal"
    footer={
      <ButtonContainer>
        <StandardButton
            look={ButtonLooks.Tertiary}
            onClick={onCancel}
            size={ButtonSizes.XSmall}
        >
            <Trans>Cancel</Trans>
        </StandardButton>
        <StandardButton
          look={ButtonLooks.Warning}
          onClick={onDisable}
          size={ButtonSizes.XSmall}
        >
          <Trans>Yes, Disable People Tagging</Trans>
        </StandardButton>
    </ButtonContainer>
    }
    id="people-tag-scope-confirm-modal"
    labels={{
      closeButtonLabel: t`Close`
    }}
    open={isOpen}
    setOpen={(open): void => {
      if (!open) onCancel();
    }}
    showTitle
    size={DialogSizes.Small}
    title={t`Disable People Tagging?`}
  >
    <ListTitleText>
      <Trans>Disabling People Tagging will:</Trans>
    </ListTitleText>
    <List>
      <li><Trans>Hide People Tagging from the UI</Trans></li>
      <li><Trans>Stop facial recognition processing for new assets</Trans></li>
    </List>
    <BodyText>
      <Trans>Existing people identities and tags will remain in this Brandfolder.</Trans>
    </BodyText>
    <BodyText>
      <Trans>
        If you need all People Tagging data permanently removed, please contact
        Support to request a full data removal.
      </Trans>
    </BodyText>
    <BodyText>
      <Trans>Are you sure you want to continue?</Trans>
    </BodyText>
  </StyledDialog>
  );
};

export default PeopleTaggingDisableModal;
